var site = site || {};

(function ($) {
// Primary object for handling the blog_teaser_image_quote_v1 template
  Drupal.behaviors.blogTeaserImageQuoteV1 = {
    elements: {},

    setHeights: function () {
      var self = this;

      self.elements.formatter.each(function () {
        var $f = $(this),
          $m = $f.find('.masthead'),
          h = $m.outerHeight(true);

        // Manually set the heights of the quote div's
        $f
          .find('.quote')
          .css({ visibility: 'visible' })
          .children('.inner')
          .addBack()
          .css({ height: h });
      });
    },

    linkMasthead: function () {
      var self = this;

      self.elements.formatter.each(function () {
        var $f = $(this),
          $m = $f.find('.masthead[path]');

        if ($m.length > 0) {
          var url = $m.attr('path');

          $f.once('blog-teaser-image-quote-clicker').on('click', function(e) {
            window.location.href = url;
          });
        }
      });
    },

    init: function () {
      var self = this;

      self.linkMasthead();
      self.setHeights();
    }
  };

  // Initialize a single instance of the template behavior
  site.blogTeaserImageQuoteV1 = Drupal.behaviors.blogTeaserImageQuoteV1;
  site.blogTeaserImageQuoteV1.elements = {
    formatter: $('.blog-teaser-image-quote.v1')
  };

  // Set the window load and resize events
  $(window)
    .on('load', function() {
      site.blogTeaserImageQuoteV1.init();
    })
    .resize(function () {
      site.blogTeaserImageQuoteV1.setHeights();
    });
})(jQuery);
